module.exports = __webpack_public_path__ + "img/emerald.7a3dec8a.png";